import { apiLiveScore } from "api"
import IconCalendar from "assets/icon/iconCalendar"
import IconDiamond from "assets/icon/iconDiamond"
import IconGamepad from "assets/icon/iconGamepad"
import IconGift from "assets/icon/iconGift"
import IconGolf from "assets/icon/iconGolf"
import IconMusic from "assets/icon/iconMusic"
import IconRouter from "assets/icon/iconRouter"
import IconSport from "assets/icon/iconSport"
import IconSport1 from "assets/icon/iconSport1"
import IconSport2 from "assets/icon/iconSport2"
import IconTelevisionSimple from "assets/icon/iconTelevisionSimple"
import IconTrophy from "assets/icon/iconTrophy"
import IconTurbine from "assets/icon/iconTurbine"
import Image from "next/legacy/image"
import Link from "next/link"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"

const Sidebar = ({ isCollapsed, setIsCollapsed, isMobile }) => {
  const router = useRouter()
  const [index, setIndex] = useState("/")
  const [subjects, setSubjects] = useState([])

  useEffect(() => {
    setIndex(router.asPath)
  }, [router])

  useEffect(() => {
    const fetch = async () => {
      const { data } = await apiLiveScore.getSubjects()
      setSubjects(data)
    }

    fetch()
  }, [])

  if (isMobile) return null

  return (
    <div
      className={`fixed left-6 flex flex-col justify-between h-[844px] rounded-3xl py-6 px-4 z-10 bg-[#232323] max-[1199.5px]:hidden ${
        !isCollapsed ? "w-[255px]" : ""
      }`}
    >
      <div className={`flex flex-col gap-1 w-full ${!isCollapsed ? "" : "items-center"}`}>
        <div className="flex w-full items-center justify-between">
          {!isCollapsed && <span className="text-base leading-[22px] font-semibold pl-2 text-[#AFAFAF]">KHÁM PHÁ</span>}
          <button onClick={() => setIsCollapsed(!isCollapsed)} className="hover:bg-[#2E2E2E] rounded-xl p-3">
            {!isCollapsed ? <img src="/icons/iconArrowExpand.svg" /> : <img src="/icons/iconArrowImport.svg" />}
          </button>
        </div>

        {subjects.map((item) => {
          return (
            <Link href={`/subject?id=${item.id}`} key={item.id} onClick={() => setIndex(`/subject?id=${item.id}`)}>
              <div
                className={`flex w-full rounded-xl gap-2 p-3 items-center cursor-pointer hover:bg-[#2E2E2E] text-[#FAFAF9] ${
                  index === `/subject?id=${item.id}` ? "font-medium text-primary" : ""
                }`}
              >
                {item.icon.toLowerCase().includes("gift") && (
                  <IconGift color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                )}
                {item.icon.toLowerCase().includes("router") && (
                  <IconRouter color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                )}
                {item.icon.toLowerCase().includes("televisionsimple") && (
                  <IconTelevisionSimple color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                )}
                {item.icon.toLowerCase().includes("trophy") && (
                  <IconTrophy color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                )}
                {item.icon.toLowerCase().includes("turbine") && (
                  <IconTurbine color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                )}
                {item.icon.toLowerCase().includes("dimond_alt") && (
                  <IconDiamond color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                )}
                {item.icon.toLowerCase().includes("games") && (
                  <IconGamepad color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                )}
                {item.icon.toLowerCase().includes("music") && (
                  <IconMusic color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                )}
                {item.icon.toLowerCase().includes("golf") && (
                  <IconGolf color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                )}
                {item.icon.toLowerCase().includes("sport-2") ? (
                  <IconSport2 color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                ) : item.icon.toLowerCase().includes("sport-1") ? (
                  <IconSport1 color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                ) : item.icon.toLowerCase().includes("sport") ? (
                  <IconSport color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                ) : null}
                {!isCollapsed && <span>{item.name}</span>}
              </div>
            </Link>
          )
        })}

        <Link href={`/schedule`} onClick={() => setIndex("schedule")}>
          <div
            className={`flex w-full rounded-xl gap-2 p-3 items-center cursor-pointer hover:bg-[#2E2E2E] text-[#FAFAF9] ${
              index === "/schedule" ? "font-medium text-primary" : ""
            }`}
          >
            {index === "/schedule" ? <IconCalendar color={"#1877F2"} /> : <IconCalendar color={"#D6D6D6"} />}
            {!isCollapsed && <span>Lịch thi đấu</span>}
          </div>
        </Link>
      </div>
      {!isCollapsed && (
        <div className="flex flex-col gap-2">
          <span className="text-xs text-[#FFFFFF61]">Tải ứng dụng tại:</span>
          <div className="flex gap-6">
            <div className="fix_img">
              <Image width={88} height={88} src={"/QRCodeONLiveTV.jpg"} />
            </div>
            <div className="flex flex-col justify-between max-[300px]:hidden">
              <Link href="https://apps.apple.com/vn/app/onlivetv/id6505140172" target="_blank" rel="noreferrer">
                <Image
                  width={110}
                  height={32}
                  src="https://stvinaprod.vtvcab.vn/91af4b21-6541-4aac-b557-eedde81a0f0a.png"
                />
              </Link>
              <div>
                <Link
                  href="https://play.google.com/store/apps/details?id=vn.vtvlive.ontv.a"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image
                    width={110}
                    height={32}
                    src="https://stvinaprod.vtvcab.vn/3c3bd6a8-bf15-48ab-9bcb-ec12ced5598e.png"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Sidebar
